import { render } from "./follow_card.vue?vue&type=template&id=e6b6839c"
import script from "./follow_card.js?vue&type=script&lang=js"
export * from "./follow_card.js?vue&type=script&lang=js"

import "./follow_card.vue?vue&type=style&index=0&id=e6b6839c&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__